'use strict';

var base = require('base/search/search');
var util = require('../util/util');


/**
 * Update Sort By select width
 */
function sortWidth() {
    $('#width_tmp_select').html($('[name=sort-order] option:selected').text());
    $('[name=sort-order]').width($('#width_tmp_select').outerWidth());
}

/**
 * Update DOM elements with Ajax results
 *
 * @param {Object} $results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 * @return {undefined}
 */
function updateDom($results, selector) {
    var $updates = $results.find(selector);
    $(selector).empty().html($updates);
    sortWidth();
}

/**
 * Keep refinement panes expanded/collapsed after Ajax refresh
 *
 * @param {Object} $results - jQuery DOM element
 * @return {undefined}
 */
function handleRefinements($results) {
    $('.refinement.active').each(function () {
        $(this).removeClass('active');
        var activeDiv = $results.find('.' + $(this)[0].className.replace(/ /g, '.'));
        activeDiv.addClass('active');
        activeDiv.find('button.title').attr('aria-expanded', 'true');
    });

    updateDom($results, '.refinements');
}

/**
 * Parse Ajax results and updated select DOM elements
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function parseResults(response) {
    var $results = $(response);
    var specialHandlers = {
        '.refinements': handleRefinements
    };

    if (!$('.grid-section').hasClass('full-width-grid')) {
        $results.find('.refinements-trigger').removeClass('active');
    }

    // Update DOM elements that do not require special handling
    [
        '.grid-header',
        '.header-bar',
        '.header.page-title',
        '.product-grid',
        '.show-more',
        '.filter-bar'
    ].forEach(function (selector) {
        updateDom($results, selector);
    });

    Object.keys(specialHandlers).forEach(function (selector) {
        specialHandlers[selector]($results);
    });
}


/**
 * Makes the AJAX call to update results based on refinements
 * @param {jquery} $element - price range DOM element
 * @param {*} e (optional) The event trigger
 */
function refineSearch($element, e) {
    var refinementUrl = $element.data('href');
    if (refinementUrl.indexOf('cgid=root')) {
        var pageCategoryId = $('.js-search-container').data('categoryId');
        refinementUrl = refinementUrl.replace('cgid=root', 'cgid=' + pageCategoryId);
    }
    var priceFrom;
    var priceTo;
    var data = {
        page: $('.grid-footer').data('page-number'),
        selectedUrl: refinementUrl
    };

    if ($element.hasClass('js-price-range-form')) {
        priceFrom = $('.js-price-range-slider').data('selectedFrom');
        priceTo = $('.js-price-range-slider').data('selectedTo');
        data.pmin = priceFrom;
        data.pmax = priceTo;
    } else if ($element.hasClass('js-price-refinement-remove')) {
        priceFrom = $('.js-price-range-slider').data('initFrom');
        priceTo = $('.js-price-range-slider').data('initTo');
    }

    $element.trigger('search:filter', e);

    $.spinner().start();

    $.ajax({
        url: refinementUrl,
        data: data,
        method: 'GET',
        success: function (response) {
            parseResults(response);
            $('body').trigger('refinement:updated', {
                to: priceTo,
                from: priceFrom
            });

            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * show swatchs image
 * @param {jquery} $anchor - swatch element
 * @param {jquery} $img image element
 * @return {undefined}
 */
function showSwatchImage($anchor, $img) {
    var href = $anchor.attr('href') || '';
    var colorCode = /_color=(\d{3})/.exec(href);
    if (!colorCode || colorCode.length !== 2) return;
    var replaceString = '_' + colorCode[1] + '.jpg';
    var regExp = new RegExp('_\\d{3}.jpg', 'g');
    $img
        .attr('src', $img.attr('src').replace(regExp, replaceString))
        .attr('srcset', $img.attr('srcset').replace(regExp, replaceString));
}

var exports = {
    refineSearch: function () {
        $('body').on('search:refine', '.js-refine-bar', function (event, element) {
            refineSearch($(element), event);
        });
    },
    filter: function () {
        // Display refinements bar when Menu icon clicked
        $('.container').on('click', '.filter-button .filter-results', function () {
            $('.refinement-bar').show();
            $('.refinement-bar').siblings().attr('aria-hidden', true);
            $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', true);
            $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', true);
            $('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', true);
            $('.refinement-bar .close').focus();
            util.lockBodyScroll();
        });
    },

    closeRefinements: function () {
        // Refinements close button
        $('.container').on('click', '.refinement-bar button.close, .modal-background, .refinement-bar .secondary-bar .apply', function () {
            $('.refinement-bar, .modal-background').hide();
            $('.refinement-bar').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', false);
            $('.filter-button .filter-results').focus();
            $(this).trigger('refinement:close');
        });
    },

    resize: function () {
        // prevent initializing app_storefront_base resize function and close refinements onResize
        return;
    },

    refinementsClearButton: function () {
        // Refinements ClearFilters button
        $('body').on('click', '.filter-bar .clear-filters', function () {
            $('body').find('.secondary-bar .reset').trigger('click');
        });
        $('.container').trigger('refinement:close');
    },

    applyFilter: function () {
        // Handle refinement value selection and reset click
        $('.container').on(
            'click',
            '.refinements li button, .refinement-bar button.reset, .filter-value button, .swatch-filter button',
            function (e) {
                e.preventDefault();
                e.stopPropagation();

                refineSearch($(this), e);
            });
    },

    refinementsSort: function () {
        // Handle sort order menu for Mobile refinements section
        var $body = $('body');

        // triggering default sort options onClick Refinement Sorting options
        $body.on('click', '.sorting-options li', function (e) {
            e.preventDefault();
            var refinementOptionId = $(this).attr('data-href');
            $(this).parents('.sorting-options').find('li').removeClass('selected');
            $(this).addClass('selected');
            $body.find('.filter-container [name=sort-order]').val(refinementOptionId).trigger('change');
        });

        // Update refinement options with correct option value
        $('.container [name=sort-order]').on('search:sort', function () {
            var selectedOption = $body.find('.filter-container [name=sort-order]').val();
            $body.find('.sorting-options li').removeClass('selected');
            $body.find('.sorting-options [data-href="' + selectedOption + '"]').addClass('selected');
        });
    },
    sort: function () {
        // Handle sort order menu selection
        $('.container').on('change', '[name=sort-order]', function (e) {
            e.preventDefault();
            sortWidth();
            $.spinner().start();
            $(this).trigger('search:sort', this.value);
            $.ajax({
                url: this.value,
                data: { selectedUrl: this.value },
                method: 'GET',
                success: function (response) {
                    parseResults(response);
                    $('body').trigger('search:sortUpdated');
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },
    setSortByWidth: function () {
        $(window).on('load', function () {
            sortWidth();
        });
    },
    plpSwatchImage: function () {
        var canHover = window.matchMedia('(hover: hover)').matches;
        $('body').on('mouseenter mouseleave click', 'div.available-colors a.color-swatch', function (e) {
            var $productImage = $(this).closest('div.product-tile').find('div.tile-image img');
            var selectedSwatch = $(this).children('span.swatch-circle');
            var removeSelectedSwatch = $(this).closest('div.available-colors');
            var defaultSrc = $productImage.data('defaultSrc');
            var defaultSrcset = $productImage.data('defaultSrcset');
            if ($productImage.length === 0) return;
            if (!defaultSrc) {
                defaultSrc = $productImage.attr('src');
                defaultSrcset = $productImage.attr('srcset');
                $productImage.data('defaultSrc', defaultSrc);
                $productImage.data('defaultSrcset', defaultSrcset);
            }
            if (e.type === 'mouseenter' && canHover) {
                showSwatchImage($(this), $productImage);
            } else if (e.type === 'mouseleave' && canHover) {
                $productImage.attr('src', defaultSrc);
                $productImage.attr('srcset', defaultSrcset);
            } else if (!canHover) {
                e.preventDefault();
                showSwatchImage($(this), $productImage);
                removeSelectedSwatch.find('span.swatch-circle.selected').removeClass('selected');
                selectedSwatch.addClass('selected');
            }
        });
    },
    addQueryStringToProductURL: function () {
        /**
         * concatQueryString - Used to add query string params back to product URLs from data attr
         */
        function concatQueryString() {
            $('#maincontent').find('div.product-tile[data-querystring][data-querystring!=""]').each(function () {
                var queryString = $(this).data('querystring');
                $(this).find('a[href$=".html"]').each(function () {
                    var currentHref = $(this).attr('href');
                    $(this).attr('href', $(this).attr('href') + '?' + queryString);
                });
                $(this).removeAttr('data-querystring');
            });
        }
        concatQueryString();
        $('body').on('pagination:update search:sortUpdated refinement:updated', function () {
            concatQueryString();
        });
    }
};

module.exports = $.extend({}, base, exports);
